import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
export const DEFAULT_PAGE_SIZE = 10;
export const actions = {
    GET: createAction('ACCOUNTS/MESSAGE_TEMPLATES/GET'),
    GET_SUCCESS: createAction('ACCOUNTS/MESSAGE_TEMPLATES/GET_SUCCESS'),
    GET_MANAGED: createAction('ACCOUNTS/MESSAGE_TEMPLATES/GET_MANAGED'),
    GET_MANAGED_SUCCESS: createAction('ACCOUNTS/MESSAGE_TEMPLATES/GET_MANAGED_SUCCESS'),
    ADD: createAction('ACCOUNTS/MESSAGE_TEMPLATES/ADD'),
    ADD_SUCCESS: createAction('ACCOUNTS/MESSAGE_TEMPLATES/ADD_SUCCESS'),
    UPDATE: createAction('ACCOUNTS/MESSAGE_TEMPLATES/UPDATE'),
    UPDATE_SUCCESS: createAction('ACCOUNTS/MESSAGE_TEMPLATES/UPDATE_SUCCESS'),
    DELETE: createAction('ACCOUNTS/MESSAGE_TEMPLATES/DELETE'),
    DELETE_SUCCESS: createAction('ACCOUNTS/MESSAGE_TEMPLATES/DELETE_SUCCESS'),
    SET_PAGE: createAction('ACCOUNTS/MESSAGE_TEMPLATES/SET_PAGE'),
    SET_PAGE_SIZE: createAction('ACCOUNTS/MESSAGE_TEMPLATES/SET_PAGE_SIZE'),
    SHOW_DETAILS_MODAL: createAction('ACCOUNTS/MESSAGE_TEMPLATES/SHOW_DETAILS_MODAL'),
    HIDE_DETAILS_MODAL: createAction('ACCOUNTS/MESSAGE_TEMPLATES/HIDE_DETAILS_MODAL'),
    ERROR: createAction('ACCOUNTS/MESSAGE_TEMPLATES/ERROR'),
};
export const initialState = Map({
    isProcessing: false,
    data: [],
    error: null,
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    totalElements: null,
    detailsModalVisible: false,
});
const reducer = handleActions({
    [actions.GET]: (state) => state.merge({ isProcessing: true, error: false }),
    [actions.GET_SUCCESS]: (state, action) => state.merge({ isProcessing: false, error: false, data: action.payload }),
    [actions.GET_MANAGED]: (state) => state.merge({ isProcessing: true, error: false }),
    [actions.GET_MANAGED_SUCCESS]: (state, action) => state.merge({
        data: action.payload.content,
        isProcessing: false,
        error: false,
        page: action.payload.number,
        pageSize: action.payload.size,
        totalElements: action.payload.totalElements,
    }),
    [actions.ADD]: (state) => state.merge({ isProcessing: true, error: false }),
    [actions.ADD_SUCCESS]: (state) => state.merge({ isProcessing: false, error: false }),
    [actions.UPDATE]: (state) => state.merge({ isProcessing: true, error: false }),
    [actions.UPDATE_SUCCESS]: (state) => state.merge({ isProcessing: false, error: false }),
    [actions.DELETE]: (state) => state.merge({ isProcessing: true, error: false }),
    [actions.DELETE_SUCCESS]: (state) => state.merge({ isProcessing: false, error: false }),
    [actions.SET_PAGE]: (state, action) => {
        const maxPageNum = Math.floor((state.get('totalElements') || 0) / state.get('pageSize'));
        const page = Math.max(0, Math.min(action.payload, maxPageNum));
        return state.set('page', page);
    },
    [actions.SET_PAGE_SIZE]: (state, action) => state.merge({
        page: 0,
        pageSize: action.payload,
    }),
    [actions.SHOW_DETAILS_MODAL]: (state) => state.merge({ detailsModalVisible: true }),
    [actions.HIDE_DETAILS_MODAL]: (state) => state.merge({ detailsModalVisible: false }),
    [actions.ERROR]: (state, action) => state.merge({ isProcessing: false, error: action.payload }),
}, initialState);
export const selectors = {
    totalPages: createSelector((state) => state.messageTemplates.get('totalElements'), (state) => state.messageTemplates.get('pageSize'), (totalElements, pageSize) => Math.max(Math.ceil((totalElements || 0) / pageSize), 1)),
};
export default reducer;
